import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { replace } from 'connected-react-router'

import { doVerifyClient } from '../../../controllers/SSO'

import MainView from '../components/MainView/MainView'

const mapStateToProps = () => {
  return {
    doVerifyClient,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      replace,
    },
    dispatch,
  )

const ConnectedMainView = connect(mapStateToProps, mapDispatchToProps)(MainView)

export default ConnectedMainView
